import { FormControl, MenuItem, Select as MuiSelect } from "@mui/material";
import React from "react";
import useStylesSearchTable from "./SearchTableStyle";

export default function Select(props) {
  const propsSelect = {
    // grid style: SearchTableStyle.js
    width: props.width,
    height: props.height,
  };
  const classes = useStylesSearchTable(propsSelect);
  const {
    name,
    label,
    value,
    onChange,
    options,
    typeOfSelect,
    variant,
    width,
    height,
    error = null,
  } = props;

  return (
    <FormControl
      variant={variant || "outlined"}
      size="small"
      className={classes.selectStyle}
      // inputRef={register({ required: true })}
    >
      <MuiSelect
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        {...(error && { error: true })}
        inputProps={{
          style: {
            fontSize: "12px",
            marginBottom: "0px",
            paddingBottom: "10px",
            shrink: true,
          },
        }}
      >
        <MenuItem value=""></MenuItem>
        {typeOfSelect === 1
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.title}
              </MenuItem>
            ))
          : typeOfSelect === 2
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.tipoDenuncia}
              </MenuItem>
            ))
          : typeOfSelect === 3
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.descricao}
              </MenuItem>
            ))
          : typeOfSelect === 4
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.motivo}
              </MenuItem>
            ))
          : typeOfSelect === 5
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.nome}
              </MenuItem>
            ))
          : typeOfSelect === 6
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.pais}
              </MenuItem>
            ))
          : typeOfSelect === 7
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.cidade}
              </MenuItem>
            ))
          : typeOfSelect === 8
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.pais}>
                {item.pais}
              </MenuItem>
            ))
          : typeOfSelect === 9
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.sede}
              </MenuItem>
            ))
          : typeOfSelect === 10
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.nome}
              </MenuItem>
            ))
          : typeOfSelect === 11
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.department}
              </MenuItem>
            ))
          : typeOfSelect === 12
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.funcao}
              </MenuItem>
            ))
          : typeOfSelect === 13
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.tipoDenuncia}
              </MenuItem>
            ))
          : typeOfSelect === 14
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))
            : typeOfSelect === 15
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))
            : typeOfSelect === 16
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.title}
              </MenuItem>
            ))
            : typeOfSelect === 17
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.academicyear}
              </MenuItem>
            ))
            : typeOfSelect === 18
          ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.coursDuration}
              </MenuItem>
            ))
            : typeOfSelect === 19
            ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.payment_type}
              </MenuItem>
            ))
            : typeOfSelect === 20
            ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.grade}
              </MenuItem>
            ))
            : typeOfSelect === 21
            ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.niveauetudes}
              </MenuItem>
            ))
            : typeOfSelect === 22
            ? options.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.cours}
              </MenuItem>
            ))

            
          : options.map((item) => (
              <MenuItem key={item.id} value={item.title}>
                {item.title}
              </MenuItem>
            ))}
        
      </MuiSelect>
    </FormControl>
  );
}
